module.exports = __webpack_public_path__ + "static/img/order-success-icon.9056fe7e.png";